import { render, staticRenderFns } from "./PoliciesListUserHasNoPolicies.vue?vue&type=template&id=45744a28&"
import script from "./PoliciesListUserHasNoPolicies.vue?vue&type=script&lang=js&"
export * from "./PoliciesListUserHasNoPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports